import { create } from 'zustand';
import { GridFilterItem, GridPaginationModel } from "@mui/x-data-grid-pro";

type DataGridState = {
  advanceSearch: Record<string, GridFilterItem[]>;
  setAdvanceSearch: (moduleName: string, filters: GridFilterItem[]) => void;
  pagination:Record<string, GridPaginationModel>;
  setPagination: (moduleName: string, pagination: GridPaginationModel) => void;
  quickFilter: Record<string, GridFilterItem>;
  setQuickFilter: (moduleName: string, filters: GridFilterItem) => void;
  advanceSearchTriggered: boolean;
  setAdvanceSearchTriggered: (value:boolean) => void;
  quickSearchField: string;
  setQuickSearchField: (value:string) => void;
  operator:string,
  setOperator: (value:string) => void
  quickSearchValue:string,
  setQuickSearchValue: (value:string) => void
  resetQuickFilter: () => void,
  filterActive: boolean,
  setFilterActive: (value:boolean) => void
};

// Initialize Zustand store
export const useDataGridStore = create<DataGridState>((set) => ({
  advanceSearch: {},
  advanceSearchTriggered: false,
  pagination: {},
  quickFilter:{},
  quickSearchField:"q",
  operator:"==",
  quickSearchValue:"",
  filterActive:false,
  setFilterActive: (value) => set({ filterActive: value }),
  resetQuickFilter: () => set({ quickFilter: {},quickSearchField:"q",quickSearchValue:"" }),
  setQuickSearchValue: (value) => set({ quickSearchValue: value }),
  setOperator: (value) => set({ operator: value }),
  setQuickSearchField: (value) => set({ quickSearchField: value }),
  setQuickFilter: (moduleName, filters) => set((state) => ({
      quickFilter: { [moduleName]: filters },
  })),
  setPagination: (moduleName, paginationModel) =>
    set((state) => {
      const current = state.pagination[moduleName];
      if (
        current &&
        Number(current.page) === Number(paginationModel.page) &&
        Number(current.pageSize) === Number(paginationModel.pageSize)
      ) {
        return state;
      }
      return {
        pagination: { ...state.pagination, [moduleName]: paginationModel },
      };
    }),
  setAdvanceSearchTriggered: (value) => set({ advanceSearchTriggered: value }),

  setAdvanceSearch: (moduleName, filters) =>
    set((state) => ({
      advanceSearch: { ...state.advanceSearch, [moduleName]: filters },
    })),
}));
